import { selectSortedOpportunityLists } from "../../../store/selectors";
import { createSelector } from "reselect";
import type { RootState } from "single-spa/store/types";

// Custom selector for creating new lists with disabled prop
export const selectListsWithDisabledProp = createSelector(
    selectSortedOpportunityLists,
    (_state: RootState, props: { disabledLists?: string[] }) => props.disabledLists,
    (newSalesLists, disabledLists = []) => {
        const createDisabled = (list: any) => {
            const disabled = !!disabledLists.find((id) => id === list.opportunityListId);
            const newList = {
                ...list,
                disabled,
            };

            return newList;
        };

        return newSalesLists.map(createDisabled);
    },
);
